import React, { useState } from 'react';
import { Calendar, Users, Clock, AlertTriangle, History, ShieldCheck, ClipboardList } from 'lucide-react';
import AttendanceDashboard from './AttendanceDashboard';
import AttendanceAlerts from './AttendanceAlerts';
import AttendanceChangeLog from './AttendanceChangeLog';
import UserManagement from '../Users/UserManagement';
import OvertimeApprovals from '../Overtime/OvertimeApprovals';
import ShiftManagement from './ShiftManagement';
import OTVerification from './OTVerification';

const tabs = [
  { id: 'attendance',   label: 'Attendance', icon: Calendar      },
  { id: 'alerts',       label: 'Alerts',               icon: AlertTriangle  },
  { id: 'change-log',   label: 'Audit',           icon: ClipboardList  },
  { id: 'users',        label: 'Users',      icon: Users          },
  { id: 'overtime',     label: 'OT Approvals',   icon: Clock          },
  { id: 'ot-verification', label: 'OT Verification',  icon: ShieldCheck    },
  { id: 'shifts',       label: 'Shifts',     icon: History        },
];

const HRPanel = () => {
  const [activeTab, setActiveTab] = useState('attendance');

  return (
    <div className="space-y-6 max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
      <div className="flex justify-between items-center mb-2">
        <h1 className="text-2xl font-bold text-gray-900">HR Operations</h1>
      </div>

      {/* Tabs Navigation */}
      <div className="border-b border-gray-200 bg-white shadow-sm rounded-t-lg px-4 pt-2">
        <nav className="-mb-px flex space-x-8 overflow-x-auto">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              className={`${
                activeTab === id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`}
            >
              <Icon className="h-5 w-5 mr-2" />
              {label}
            </button>
          ))}
        </nav>
      </div>

      {/* Render Active Tab Content */}
      <div className="mt-6">
        {activeTab === 'attendance'      && <AttendanceDashboard />}
        {activeTab === 'alerts'          && <AttendanceAlerts />}
        {activeTab === 'change-log'      && <AttendanceChangeLog />}
        {activeTab === 'users'           && <UserManagement />}
        {activeTab === 'overtime'        && <OvertimeApprovals />}
        {activeTab === 'ot-verification' && <OTVerification />}
        {activeTab === 'shifts'          && <ShiftManagement />}
      </div>
    </div>
  );
};

export default HRPanel;
